import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/library", label: "Library" },
  { to: "/author", label: "Author" },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-cabinet font-bold text-[#0A0A0A] text-lg tracking-tight">
            The AI Mastery Series
          </span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`text-sm font-medium link-underline transition-colors ${
                location.pathname === link.to
                  ? "text-[#0A0A0A]"
                  : "text-[#666666] hover:text-[#0A0A0A]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/read/what-ai-is-not"
            data-testid="nav-start-reading"
            className="bg-[#FF4F00] text-white px-5 py-2 text-sm font-medium hover:bg-[#E64700] transition-colors"
          >
            Start Reading
          </Link>
        </div>

        {/* Mobile menu */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <button data-testid="nav-mobile-menu" className="p-2">
              <Menu size={22} />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[280px] bg-white p-0">
            <div className="flex flex-col pt-12">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className="px-6 py-4 border-b border-[#E5E5E5] text-sm font-medium text-[#0A0A0A] hover:bg-[#F0F0F0] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <div className="px-6 pt-6">
                <Link
                  to="/read/what-ai-is-not"
                  onClick={() => setOpen(false)}
                  className="block bg-[#FF4F00] text-white px-5 py-3 text-sm font-medium text-center hover:bg-[#E64700] transition-colors"
                >
                  Start Reading
                </Link>
              </div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
}
